module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-2.a4556648.mp3";